<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ (isNew ? 'response.edit.add' : 'response.edit.edit') | translate }} {{ 'response.edit.response' | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label">{{ 'response.edit.responseName' | translate }} *</label>
            <input
              type="text"
              class="form-control"
              formControlName="name"
              [placeholder]="'response.edit.responseNamePlaceholder' | translate"
              maxlength="100"
            />
            <field-error-component
              [field]="'name'"
              [label]="'response.edit.name' | translate"
              [formGroup]="formGroup"
            />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ (isNew ? 'response.edit.selectCategory' : 'response.edit.responseCategory') | translate }} *</label>
            <mat-select
              class="form-control"
              formControlName="category"
              [placeholder]="'response.edit.select' | translate"
              (focus)="onFocusCategory()"
            >
              @for (item of listCategory; track item) {
                <mat-option [value]="item._id">{{ item.name }}</mat-option>
              }
            </mat-select>
            <field-error-component
              [field]="'category'"
              [label]="'response.edit.category' | translate"
              [formGroup]="formGroup"
            />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'response.edit.responseType' | translate }} *</label>
            <div class="d-flex">
              @for (option of responseTypes; track option) {
                <div class="form-check form-check-inline form-radio-info">
                  <input
                    type="radio"
                    class="form-check-input"
                    formControlName="typeResponse"
                    [value]="option.value"
                    [id]="option.value"
                    name="typeResponse"
                  />
                  <label class="form-check-label" [for]="option.value">{{ option.label | translate }}</label>
                </div>
              }
            </div>
          </div>

          @if (isTypeContact() && !getContact()) {
            <div class="col-12 m">
              <button
                type="button"
                class="btn btn-link text-primary p-0"
                (click)="selectContact()"
              >
                {{ 'response.edit.selectContact' | translate }}
              </button>
            </div>
          }

          @if (isTypeLocation() && !getPlace()) {
            <div class="col-12 m">
              <button
                type="button"
                class="btn btn-link text-primary p-0"
                (click)="selectLocation()"
              >
                {{ 'response.edit.selectLocation' | translate }}
              </button>
            </div>
          }

          @if (isTypeButton()) {
            <app-button-zapi-component
              [buttonActionsArray]="getButtonActionsFormArray()"
              [maxButtons]="3"
              [showFullMessage]="true"
              [title]="formGroup.get('title').value"
              [message]="formGroup.get('message').value"
              [footer]="formGroup.get('footer').value"
              (titleChange)="formGroup.get('title').setValue($event)"
              (messageChange)="formGroup.get('message').setValue($event)"
              (footerChange)="formGroup.get('footer').setValue($event)">
            </app-button-zapi-component>
          }

          @if (isTypeText()) {
            <div class="col-12 mb-1">
              <label class="form-label">{{ 'response.edit.message' | translate }} *</label>
              <textarea
                class="form-control"
                formControlName="message"
                [placeholder]="'response.edit.messagePlaceholder' | translate"
                rows="5"
                maxlength="1600"
              >
              </textarea>

              <field-error-component [field]="'message'" [label]="'response.edit.message' | translate" [formGroup]="formGroup" />
              <mat-menu #menuVar="matMenu">
                @for (variable of templateVariableListWithNameAttendant; track variable) {
                  <button
                    mat-menu-item
                    (click)="setVariableInContent(variable.value)">
                    <mat-icon color="primary">{{ variable.icon }}</mat-icon>
                    {{ variable.label }}
                  </button>
                }
              </mat-menu>

              <div class="d-flex justify-content-end mt-2">
                <i [matMenuTriggerFor]="menuVar" class="cursor-pointer ri-code-line"></i>
              </div>

            </div>

            <div class="col-12 d-flex justify-content-center mb-3">
              <div class="text-center w-100">

                @if (loadingSpinner$ | async) {
                  <loading-component />
                }

                @if (response.midia) {
                  <div class="d-flex flex-column align-items-center">
                    <img [src]="midiaImage()" class="img-fluid rounded object-fit-contain" [alt]="'response.edit.yourImage' | translate" />
                    <button
                      class="btn btn-outline-danger mt-2"
                      type="button"
                      (click)="removeMidia()"
                    >
                      <i class="mdi mdi-trash-can-outline me-1"></i> {{ 'response.edit.remove' | translate }}
                    </button>

                  </div>
                } @else {
                  <div class="upload-area" [ngClass]="{ 'has-image': response.midia }">
                    @if (loadingSpinner$ | async) {
                      <loading-component class="loading" diameter="20" />
                    } @else {
                      @if (!response.midia) {
                        <div class="placeholder-content" (click)="fileInputFile.click()">
                          <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                          <p class="text-primary fw-semibold">{{ 'response.edit.clickToUpload' | translate }}</p>
                          <p class="text-muted small">{{ 'response.edit.uploadFormats' | translate }}</p>
                        </div>
                      }
                    }

                    <div class="upload-area__image" [ngStyle]="(loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}">
                      @if (response.midia) {
                        <figure class="figure-img">
                          <img
                          [alt]="'response.edit.preview' | translate"
                          class="preview-img"
                          [src]="midiaImage()"
                          (click)="$event.stopPropagation()" />
                        </figure>

                        <button
                          class="btn btn-outline-danger mt-2"
                          type="button"
                          (click)="removeMidia(); $event.stopPropagation()"
                        >
                          <i class="mdi mdi-trash-can-outline me-1"></i> {{ 'response.edit.remove' | translate }}
                        </button>
                      }
                    </div>

                    <input
                      #fileInputFile
                      type="file"
                      accept="image/jpeg, image/png, image/jpg, application/pdf, audio/*"
                      (change)="onFileSelected($event)" />
                  </div>
                }
              </div>
            </div>
          }

          @if (isTypeContact() && getContact()) {
            <div class="card-body table-responsive">
              <table class="table table-hover table-centered mb-0">
                <thead>
                  <tr>
                    <th class="text-primary-emphasis">{{ 'response.edit.name' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'response.edit.email' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'response.edit.phone' | translate }}</th>
                    <th><span class="sr-only"></span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="table-user-thumbnail d-flex align-items-center">
                        <img
                          class="me-2 rounded-circle imageSize"
                          [src]="getContactImage(getContact())"
                          [alt]="$safeNavigationMigration(getContact()?.name)"
                          (error)="onImageError($event)"
                          width= "40"
                          height="40"
                        />
                        <strong class="text-truncate">{{getContact()?.name}}</strong>
                      </span>
                    </td>

                    <td>{{ getContact()?.email ?? '-' | truncate: 50 }}</td>
                    <td>{{ getContact()?.phone }}</td>

                    <td class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        <button mat-menu-item tabindex="0" (click)="removeContact()">{{ 'response.edit.delete' | translate }}</button>
                      </mat-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          }

          @if (isTypeLocation() && getPlace()) {
            <div class="card-body table-responsive">
              <table class="table table-hover table-centered mb-0">
                <thead>
                  <tr>
                    <th class="text-primary-emphasis">{{ 'response.edit.address' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'response.edit.longitude' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'response.edit.latitude' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ getPlace()?.formattedAddress ?? ('response.edit.selectedLocation' | translate) | truncate: 50 }}</td>
                    <td>{{ getPlace()?.location.longitude }}</td>
                    <td>{{ getPlace()?.location.latitude }}</td>
                    <td class="d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-dropdown-list"
                        [matMenuTriggerFor]="menu"
                      >
                        <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                      </button>

                      <mat-menu #menu="matMenu">
                        <button mat-menu-item tabindex="0" (click)="removePlace()">{{ 'response.edit.delete' | translate }}</button>
                      </mat-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'response.edit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="formGroup.invalid || loading"
      >
        {{ (isNew ? 'response.edit.save' : 'response.edit.edit') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>
